import React, {Component} from 'react'

import styled from '@emotion/styled'
import StyleVariales from '../styles/styles'
import AuthBase from '../components/AuthBase'
import AuthButton from '../components/AuthButton'

import {withTranslation} from "react-i18next";
import {AnimatedLoader, Container, StyledMedia} from "../styles/CommonStyler";
import {Header} from "../components/Header";
import Footer from "../components/Footer";
import {connect} from "react-redux";
import {alertActions, userActions} from "../_actions";
import {alertActionTypes} from "../_constants";
import AuthError from "../components/AuthError";
import {isMobileOnly} from "react-device-detect";

// STYLE ##########################################################

const sv = StyleVariales;

const Actions = styled(`div`)`
  margin-top: 24px;
  ${sv.flexRow};
`;

const Message = styled('div')`
    margin-bottom: 32px;
`;

const IsVerifying = styled(`div`)`
  width: 100%;
  height: 48px;
  color: ${sv.colors.cta};
  ${sv.flexCenter};
  h3 {
    margin-right: 16px;
  }
`;

// COMPONENT ##########################################################

class CancelAccount extends Component {

    constructor(props) {
        super(props);

        this.handleAccountCancellation = this.handleAccountCancellation.bind(this);
    }

    handleAccountCancellation(e) {
        e.preventDefault();
        this.props.clearAlert();    // clear previous error
        this.props.cancelAccount(); // call dispatcher
    }

    render() {
        const {t, users, alert} = this.props;
        const {accountCancellation: request} = users;
        return (
            <StyledMedia>
                <Container isMobile={isMobileOnly}>

                    <Header/>

                    <AuthBase title={t('Cancel Account')}>
                        {/* Show error if request made, is not pending and failed */}
                        { (request && !request.isLoading && !request.isSuccess) &&
                            alert.type === alertActionTypes.ERROR &&
                            <AuthError error={alert.message.errorMsg}/>
                        }

                        {/*
                            1. No request made yet
                            2. Request made but is not successful yet
                          */}
                        {(!request || (request && !request.isSuccess)) &&
                        <>
                            <Message>{t("Are you sure you'd like to cancel your account?")}</Message>
                            <Message>{t("Your Gists will no longer be available. This cannot be undone.")}</Message>
                        </>
                        }
                        <Actions>
                            {/* No request OR until request processing started */}
                            { (!request || (request && !request.isLoading && !request.isSuccess)) &&
                            <>
                                <AuthButton cancel longText
                                            onClick={() => this.props.history.goBack()}>{t("Don't cancel my account")}</AuthButton>
                                <AuthButton longText
                                    onClick={this.handleAccountCancellation}>{t("Yes, cancel my account")}</AuthButton>
                            </>
                            }

                            {/* Request made and is loading */}
                            {(request && request.isLoading && !request.isSuccess) &&
                            <IsVerifying>
                                <h3>{t('Canceling Account...')}</h3>
                                <AnimatedLoader color={sv.colors.cta}/>
                            </IsVerifying>
                            }
                        </Actions>
                        
                        {/* Request made and account cancellation is successful */}
                        {request && request.isSuccess &&
                            <Message>{t("Your account has been canceled. We're extremely sorry to see you go.")}</Message>
                        }
                    </AuthBase>

                    <Footer />

                </Container>
            </StyledMedia>
        )
    }
}

function mapStateToProps(state) {
    const {users, alert} = state;
    return {
        users, alert
    };
}

function mapDispatchToProps(dispatch) {
    return {
        cancelAccount   : () => dispatch( userActions.cancelAccount() ),
        clearAlert      : ()        => dispatch(alertActions.clear()),
    };
}

const connectedCancelAccount = withTranslation()(connect(mapStateToProps, mapDispatchToProps)(CancelAccount));
export { connectedCancelAccount as CancelAccount };
